export default __webpack_public_path__ + "static/media/VideoThumbnail2.d4187469.svg";